// extracted by mini-css-extract-plugin
export default {"deviceButton":"HangUpButton_deviceButton__oDVy4","icon":"HangUpButton_icon__FaobF"};